import { JoinableAppointmentParams } from 'app/dashboard/components/upcomingAppointments/interfaces/upcomingAppointments.interfaces';
import { useCallback, useEffect, useState } from 'react';
import {
  MILLISECONDS_IN_SEC,
  SECONDS_IN_MIN,
} from '../utilities/constants/time';
import { AppointmentHasuraStatus } from '../app/my-appointments/const/appointment';

const joinableStatuses = [AppointmentHasuraStatus.Booked];
const SHOW_LINK_BEFORE_START_TIME = 30 * SECONDS_IN_MIN * MILLISECONDS_IN_SEC;

export function useIsJoinable(appointment: JoinableAppointmentParams) {
  const {
    startDate: appointmentStartDate,
    endDate: appointmentEndDate,
    appointmentStatus,
  } = appointment;
  const [isJoinable, setIsJoinable] = useState(false);
  const [isComing, setComing] = useState(false);

  const checkTime = useCallback(() => {
    if (
      !joinableStatuses.includes(appointmentStatus as AppointmentHasuraStatus)
    ) {
      setIsJoinable(false);
      return;
    }
    const appointmentStartTime = new Date(appointmentStartDate).getTime();
    const appointmentEndTime = new Date(appointmentEndDate || '').getTime();
    const now = Date.now();
    const timeDiff = appointmentStartTime - now;
    setIsJoinable(
      timeDiff <= SHOW_LINK_BEFORE_START_TIME && now < appointmentEndTime,
    );
    setComing(timeDiff <= 0 && now < appointmentEndTime);
  }, [appointmentEndDate, appointmentStartDate, appointmentStatus]);

  useEffect(() => {
    checkTime();
    const intervalId = setInterval(checkTime, MILLISECONDS_IN_SEC);

    return () => clearInterval(intervalId);
  }, [checkTime]);

  return { isJoinable, isComing };
}
